import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { MODIFY_BOOKING, MODIFY_BOOKING_ERROR, MODIFY_BOOKING_SUCCESS } from '../../../actions.js';

function* modifyBooking({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/modify-booking`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: {
        ...payload?.body,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: MODIFY_BOOKING_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: MODIFY_BOOKING_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: MODIFY_BOOKING_ERROR, payload: error });
  }
}

export function* watchmodifyBooking() {
  yield takeEvery(MODIFY_BOOKING, modifyBooking);
}

function* modifyBookingSaga() {
  yield all([fork(watchmodifyBooking)]);
}

export default modifyBookingSaga;
